import { AppExceptionResponseData } from '../../../hooks/useHandleAppException';
import { ErrorResponse } from '../../../lib/basicRepository';
import { formatFilterIdsSearchParams } from '../../../modules/catalogs/products/catalogFilters.utils';
import { ESProductCatalogSearch } from '../../../modules/catalogs/products/product-catalog-es.types';
import { catalogsRepository } from '../../../modules/catalogs/repositories/catalogs.repository';
import { restApi } from '../../api';
import {
  FetchCatalogProductsPageParams,
  MoveCatalogItemParams,
  RemoveCatalogProductsParams,
} from './catalogProducts.types';

export const fetchCatalogProductsPage = async (
  params: FetchCatalogProductsPageParams,
): Promise<ESProductCatalogSearch[]> => {
  const {
    catalogId,
    page,
    pageSize,
    contextParams,
    sortParams,
    groupParams,
    filters,
    customerIds,
    gridDataInclude,
    isOfflineMode,
    offlineSectionProductSet,
  } = params;

  const formattedFilters = formatFilterIdsSearchParams(filters, customerIds);

  const response = await catalogsRepository(catalogId, isOfflineMode).getESProductCatalogSearch(
    {
      page,
      count: pageSize,
      params: {
        ...contextParams,
        ...sortParams,
        ...groupParams,
        ...formattedFilters,
        ...(gridDataInclude ? { includeGridData: true } : {}),
      },
    },
    offlineSectionProductSet,
  );

  if (response.tag === 'error') {
    throw response.error;
  }

  return response.data;
};

export const moveCatalogItem = ({
  catalogId,
  sectionId,
  sectionProductId,
  toSectionId,
  afterItemId,
}: MoveCatalogItemParams) =>
  restApi.patch<void, ErrorResponse>(
    `catalogs/${catalogId}/sections/${sectionId}/items/${sectionProductId}/move`,
    { toSectionId, afterItemId },
  );

export const removeCatalogProducts = ({
  catalogId,
  itemIds,
  isAdminSeller,
}: RemoveCatalogProductsParams) =>
  restApi.delete<void, AppExceptionResponseData>(
    `catalogs/${catalogId}/products`,
    { isAdminSeller },
    { data: { itemIds } },
  );
